import { render } from "./MinimalButton.vue?vue&type=template&id=286967e3&scoped=true"
import script from "./MinimalButton.vue?vue&type=script&lang=js"
export * from "./MinimalButton.vue?vue&type=script&lang=js"

import "./MinimalButton.vue?vue&type=style&index=0&id=286967e3&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286967e3"]])

export default __exports__